import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("en-SG", {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const Footer = ({ className = "" }) => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/build-info")
      .then((r) => { if (alive) setInfo(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const version = info?.version || "v1";
  const sha = info?.git_sha && info.git_sha !== "unknown" ? info.git_sha : null;
  const built = info?.deploy_timestamp ? fmtDate(info.deploy_timestamp) : "—";
  const title = info
    ? `${info.maturity} · ${info.commits?.toLocaleString?.() ?? info.commits} commits · ${info.environment} · deployed ${fmtDate(info.deploy_timestamp)}`
    : undefined;

  return (
    <footer
      data-testid="global-footer"
      className={`border-t border-border bg-background shrink-0 ${className}`}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
        <span data-testid="footer-version" className="font-mono" title={title}>
          {version}
          {info?.phase != null && <> · <span data-testid="footer-phase">phase {info.phase}</span></>}
          {sha && <> · <span data-testid="footer-sha">{sha}</span></>}
          {" · built "}
          <span data-testid="footer-built">{built}</span>
        </span>
        <a
          href="https://sustek.ai"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-copyright"
          className="hover:text-foreground transition-colors"
        >
          Copyright © SusTek Pte Ltd. All Rights Reserved.
        </a>
      </div>
    </footer>
  );
};

export default Footer;
